export default __webpack_public_path__ + "static/unionpay-d64b7a61e9ffc7fe16894309e39ac59b.jpg";